/* @flow */
import * as React from 'react';

const QuoteBadge = props => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <circle fill="#677BC5" cx={16} cy={16} r={16} />
    <path
      fill="#FFFFFF"
      d="M23,18.462 C23,16.812 21.777,15.881 20.282,15.881 C19.783,15.881 19.511,15.965 19.375,16.092 C19.421,14.358 20.78,12.454 22.773,11.988 L22.773,10 C20.236,10.212 16.748,12.454 16.748,17.404 C16.748,19.815 18.288,21 20.055,21 C21.731,21 23,19.858 23,18.462 Z M15.252,18.462 C15.252,16.812 14.029,15.881 12.534,15.881 C12.036,15.881 11.764,15.965 11.628,16.092 C11.673,14.358 13.032,12.454 15.026,11.988 L15.026,10 C12.489,10.212 9,12.454 9,17.404 C9,19.815 10.54,21 12.307,21 C13.984,21 15.252,19.858 15.252,18.462 Z"
    />
  </svg>
);

export default QuoteBadge;



// WEBPACK FOOTER //
// ./src/assets/images/icons/quote-badge.js